import React from "react";
import pdProtection from '../assets/files/en/personal_data_processing_policy.pdf';

const PersonaDataProcessingPolicyEn = () => {
    React.useEffect(() => {
        if (pdProtection) {
            window.location.href = pdProtection;
        } else {
            console.error(`PDF: ${pdProtection} file not found`);
        }
    }, []);

    return null;
};

export default PersonaDataProcessingPolicyEn;